var thirdpartyInsuranceSearch = function (vehicle_id, inturance_type, cartype_id, carmodel_id, thirdparty_build_year,
      thirdparty_damage_type, thirdparty_undamaged, thirdparty_damaged, thirdparty_discount_damage_financial,
      thirdparty_discount_damage_life, thirdparty_driver_undamaged, thirdparty_driver_damaged, thirdparty_driver_discount_damage,
      thirdparty_expire_day, thirdparty_expire_month, thirdparty_expire_year, thirdparty_start_day, thirdparty_start_month,
      thirdparty_start_year, thirdparty_owner_select, thirdparty_previous_company_select,
      thirdparty_insurance_inquiry_method, part1, part2, part3, part4, thirdparty_national_code, thirdparty_discount_status_select) {

      function padJalaliPart(value) {
            var n = parseInt(value, 10);
            if (isNaN(n)) {
                  return '';
            }
            return n < 10 ? '0' + n : String(n);
      }

      function toEnglishDigits(str) {
            if (!str) {
                  return '';
            }
            return String(str)
                  .replace(/[۰-۹]/g, function (d) { return String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)); })
                  .replace(/[٠-٩]/g, function (d) { return String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)); });
      }

      function buildJalaliDate(year, month, day) {
            year = toEnglishDigits(year);
            month = toEnglishDigits(month);
            day = toEnglishDigits(day);
            if (!year || !month || !day || year === 'NAN' || month === 'NAN' || day === 'NAN') {
                  return '';
            }
            var y = parseInt(year, 10);
            var m = padJalaliPart(month);
            var d = padJalaliPart(day);
            if (isNaN(y) || !m || !d) {
                  return '';
            }
            return y + '/' + m + '/' + d;
      }

      function readJalaliDate(prefix) {
            var day = $('#thirdparty_' + prefix + '_date_day_select').val();
            var month = $('#thirdparty_' + prefix + '_date_month_select').val();
            var year = $('#thirdparty_' + prefix + '_date_year_select').val();
            var fromSelects = buildJalaliDate(year, month, day);
            if (fromSelects) {
                  return fromSelects;
            }
            var pickerVal = toEnglishDigits($('#thirdparty_' + prefix + '_date_picker').val() || '');
            if (!pickerVal) {
                  return '';
            }
            var parts = pickerVal.split(/[\/\-\.]/);
            if (parts.length !== 3) {
                  return '';
            }
            return buildJalaliDate(parts[0], parts[1], parts[2]);
      }

      function showFieldError($field, message) {
            var $target = $field;
            if ($field && $field.length) {
                  if ($field.hasClass('select2-hidden-accessible')) {
                        $target = $field.next('.select2');
                  } else if ($field.next('.select2').length) {
                        $target = $field.next('.select2');
                  } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                        $target = $field.next();
                  }
                  try {
                        $target.animateCss('shake');
                  } catch (e) {}
                  $target.addClass('thirdparty-field-error');
                  setTimeout(function () {
                        $target.removeClass('thirdparty-field-error');
                  }, 2500);
            }
            if (typeof Swal !== 'undefined') {
                  Swal.fire({
                        icon: 'warning',
                        title: 'توجه',
                        text: message,
                        confirmButtonText: 'باشه',
                        confirmButtonColor: '#ED6D37'
                  });
            } else {
                  alert(message);
            }
            return false;
      }

      if (thirdparty_insurance_inquiry_method.is(':checked')) {

            if (part1.val() == "") {
                  return showFieldError(part1, 'لطفاً پلاک خودرو را کامل وارد کنید.');
            }
            if (part2.val() == "NAN" || part2.find("option:selected").text() == "") {
                  return showFieldError(part2, 'لطفاً حرف پلاک را انتخاب کنید.');
            }
            if (part3.val() == "") {
                  return showFieldError(part3, 'لطفاً پلاک خودرو را کامل وارد کنید.');
            }
            if (part4.val() == "") {
                  return showFieldError(part4, 'لطفاً پلاک خودرو را کامل وارد کنید.');
            }
            if (thirdparty_national_code.val() == "") {
                  return showFieldError(thirdparty_national_code, 'لطفاً کد ملی را وارد کنید.');
            }

            $.ajax(
                  {
                        type: "GET",
                        url: thirdpartyInsuranceSanhabCheckUrl,
                        data: { 'part1': part1.val(), 'part2': part2.val(), 'part3': part3.val(), 'part4': part4.val(), 'nationalCode': thirdparty_national_code.val() },
                        headers: { 'CSRF-Token': $('meta[name="CSRFToken"]').attr('content') },
                        success: function (response) {
                              var res = $.parseJSON(response);
                              if (res.status) {
                                    var info = res.data;
                                    var url_param = '';
                                    var vehicleid = (info.vehicleId != undefined) ? info.vehicleId : vehicle_id.val();
                                    var inturancetype = info.insuranceType;
                                    var cartypeid = cartype_id.val();
                                    var cartype_name = cartype_id.find("option:selected").data('value');
                                    var carmodelid = (info.carModelId != undefined) ? info.carModelId : carmodel_id.val();
                                    var thirdpartybuildyear = info.buildYear;
                                    var thirdpartypreviouscompany = info.previousCompany;
                                    var thirdpartyowner = info.insuranceOwner;
                                    var thirdpartydamagetype = info.damageType;
                                    var thirdpartyundamaged = (info.UnDamaged != undefined) ? info.UnDamaged : 0;
                                    var thirdpartydamaged = (info.Damaged != undefined) ? info.Damaged : 0;
                                    var thirdpartydiscountdamage = (info.discountDamageFinancial != undefined) ? info.discountDamageFinancial : 0;
                                    var thirdpartydiscountdamagelife = (info.discountDamageLife != undefined) ? info.discountDamageLife : 0;

                                    var thirdpartydriverundamaged = (info.DriverUnDamaged != undefined) ? info.DriverUnDamaged : 0;
                                    var thirdpartydriverdamaged = (info.DriverDamaged != undefined) ? info.DriverDamaged : 0;
                                    var thirdpartydriverdiscountdamage = (info.DriverdiscountDamage != undefined) ? info.DriverdiscountDamage : 0;
                                    if (inturancetype == 'transit') {
                                          var thirdpartyexpiredate = '';
                                          var thirdpartystartdate = '';
                                    } else {
                                          var thirdpartyexpiredate = info.expireDate;
                                          var thirdpartystartdate = info.startDate;
                                    }
                                    var now = new persianDate().toLocale('en').format('YYYY/MM/DD');
                                    var currentY = new persianDate().year();
                                    var buildY = thirdpartybuildyear.split("/");
                                    var carAge = currentY - buildY[0];
                                    if (isTejaratno && thirdpartyexpiredate < now && carAge > 15) {
                                          Swal.fire('برای استعلام قیمت به نماینده واحد صدور مراجعه گردد');
                                          return false;
                                    }
                                    if (carmodelid && carmodelid != "NAN") {
                                          url_param += '?carModelId=' + carmodelid;
                                    }

                                    if (thirdpartybuildyear && thirdpartybuildyear != "NAN") {
                                          if (carmodelid && carmodelid != "NAN") {
                                                url_param += '&';
                                          }
                                          url_param += 'buildYear=' + thirdpartybuildyear;
                                    }
                                    if (thirdpartyowner) {
                                          url_param += '&insuranceOwner=true';
                                    } else {
                                          url_param += '&insuranceOwner=false';
                                    }
                                    url_param += '&damageType=' + thirdpartydamagetype;
                                    if (thirdpartypreviouscompany != 'without') {
                                          if (thirdpartydamagetype) {
                                                url_param += '&Damaged=' + thirdpartydamaged;
                                                url_param += '&discountDamageFinancial=' + thirdpartydiscountdamage;
                                                url_param += '&discountDamageLife=' + thirdpartydiscountdamagelife;

                                                url_param += '&DriverDamaged=' + thirdpartydriverdamaged;
                                                url_param += '&DriverdiscountDamage=' + thirdpartydriverdiscountdamage;
                                          } else {
                                                url_param += '&Undamaged=' + thirdpartyundamaged;
                                                url_param += '&DriverUndamaged=' + thirdpartydriverundamaged;
                                          }
                                    }

                                    if (thirdpartyexpiredate) {
                                          url_param += '&expireDate=' + thirdpartyexpiredate;
                                    }
                                    if (thirdpartystartdate) {
                                          url_param += '&startDate=' + thirdpartystartdate;
                                    }
                                    if (vehicleid && vehicleid != "NAN") {
                                          url_param += '&vehicleId=' + vehicleid;
                                    }
                                    if (inturancetype) {
                                          url_param += '&insuranceType=' + inturancetype;
                                    }
                                    url_param += '&previousCompany=' + thirdpartypreviouscompany;
                                    window.location = thirdpartyInsuranceSearchUrl + '/' + url_param;
                              } else {
                                    Swal.fire(res.message);
                                    return false;
                              }

                        },
                        error: function () {
                        }
                  });
            return false;
      } else {

            if (vehicle_id.val() == "NAN" || vehicle_id.val() == null || vehicle_id.val() == "") {
                  return showFieldError(vehicle_id, 'لطفاً نوع وسیله نقلیه را انتخاب کنید.');
            }
            if (cartype_id.val() == "NAN" || cartype_id.find("option:selected").text() == "") {
                  return showFieldError(cartype_id, 'لطفاً نوع خودرو را انتخاب کنید.');
            }
            if (carmodel_id.val() == "NAN" || carmodel_id.find("option:selected").text() == "") {
                  return showFieldError(carmodel_id, 'لطفاً مدل خودرو را انتخاب کنید.');
            }
            if (thirdparty_build_year.val() == "NAN" || thirdparty_build_year.find("option:selected").text() == "") {
                  return showFieldError(thirdparty_build_year, 'لطفاً سال ساخت را انتخاب کنید.');
            }
            if (thirdparty_previous_company_select.val() == "NAN" || thirdparty_previous_company_select.val() == null) {
                  return showFieldError(thirdparty_previous_company_select, 'لطفاً شرکت بیمه‌گر قبلی را انتخاب کنید.');
            }
            if (thirdparty_previous_company_select.val() != 'without') {
                  var startDateCheck = readJalaliDate('start');
                  var expireDateCheck = readJalaliDate('expire');
                  if (!startDateCheck) {
                        return showFieldError($('#thirdparty_start_date_picker'), 'لطفاً تاریخ شروع بیمه‌نامه قبلی را وارد کنید.');
                  }
                  if (!expireDateCheck) {
                        return showFieldError($('#thirdparty_expire_date_picker'), 'لطفاً تاریخ سررسید بیمه‌نامه قبلی را وارد کنید.');
                  }
                  if (thirdparty_damage_type.is(':checked')) {
                        if (thirdparty_damaged.val() == null || thirdparty_damaged.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_damaged, 'لطفاً درصد عدم خسارت را انتخاب کنید.');
                        }
                        if (thirdparty_discount_damage_financial.val() == null || thirdparty_discount_damage_financial.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_discount_damage_financial, 'لطفاً تعداد خسارت مالی را انتخاب کنید.');
                        }
                        if (thirdparty_discount_damage_life.val() == null || thirdparty_discount_damage_life.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_discount_damage_life, 'لطفاً تعداد خسارت جانی را انتخاب کنید.');
                        }
                        if (thirdparty_driver_damaged.val() == null || thirdparty_driver_damaged.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_driver_damaged, 'لطفاً تخفیف حوادث بیمه‌نامه قبلی را انتخاب کنید.');
                        }
                        if (thirdparty_driver_discount_damage.val() == null || thirdparty_driver_discount_damage.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_driver_discount_damage, 'لطفاً تعداد خسارت راننده را انتخاب کنید.');
                        }
                        if (thirdparty_discount_status_select.length && thirdparty_discount_status_select.is('select')) {
                              if (thirdparty_discount_status_select.val() == null || thirdparty_discount_status_select.val() == 'NAN' || thirdparty_discount_status_select.find("option:selected").text() == "") {
                                    return showFieldError(thirdparty_discount_status_select, 'لطفاً وضعیت تخفیفات را انتخاب کنید.');
                              }
                        }
                  } else {
                        if (thirdparty_undamaged.val() == null || thirdparty_undamaged.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_undamaged, 'لطفاً درصد عدم خسارت را انتخاب کنید.');
                        }
                        if (thirdparty_driver_undamaged.val() == null || thirdparty_driver_undamaged.find("option:selected").text() == "") {
                              return showFieldError(thirdparty_driver_undamaged, 'لطفاً تخفیف حوادث بیمه‌نامه قبلی را انتخاب کنید.');
                        }
                  }
            }
            var url_param = '';
            var vehicleid = vehicle_id.val();
            var inturancetype = inturance_type.val();
            var cartypeid = cartype_id.val();
            var cartype_name = cartype_id.find("option:selected").data('value');
            var carmodelid = carmodel_id.val();
            var thirdpartybuildyear = thirdparty_build_year.val();
            var thirdpartypreviouscompany = thirdparty_previous_company_select.val();
            var thirdpartyowner = thirdparty_owner_select.is(':checked');
            var thirdpartydamagetype = thirdparty_damage_type.is(':checked');
            var thirdpartyundamaged = thirdparty_undamaged.val();
            var thirdpartydamaged = thirdparty_damaged.val();
            var thirdpartydiscountdamage = thirdparty_discount_damage_financial.val();
            var thirdpartydiscountdamagelife = thirdparty_discount_damage_life.val();

            var thirdpartydriverundamaged = thirdparty_driver_undamaged.val();
            var thirdpartydriverdamaged = thirdparty_driver_damaged.val();
            var thirdpartydriverdiscountdamage = thirdparty_driver_discount_damage.val();
            var thirdpartydiscountstatusselect = thirdparty_discount_status_select.val();
            if (inturancetype == 'transit') {
                  var thirdpartyexpiredate = '';
                  var thirdpartystartdate = '';
            } else {
                  var thirdpartyexpiredate = readJalaliDate('expire');
                  var thirdpartystartdate = readJalaliDate('start');
            }
            var now = new persianDate().toLocale('en').format('YYYY/MM/DD');
            var currentY = new persianDate().year();
            var buildY = thirdpartybuildyear.split("/");
            var carAge = currentY - buildY[0];
            if (isTejaratno && thirdpartyexpiredate < now && carAge > 15) {
                  Swal.fire('برای استعلام قیمت به نماینده واحد صدور مراجعه گردد');
                  return false;
            }
            if (carmodelid && carmodelid != "NAN") {
                  url_param += '?carModelId=' + carmodelid;
            }

            if (thirdpartybuildyear && thirdpartybuildyear != "NAN") {
                  if (carmodelid && carmodelid != "NAN") {
                        url_param += '&';
                  }
                  url_param += 'buildYear=' + thirdpartybuildyear;
            }
            if (thirdpartyowner) {
                  url_param += '&insuranceOwner=true';
            } else {
                  url_param += '&insuranceOwner=false';
            }
            url_param += '&damageType=' + thirdpartydamagetype;
            if (thirdpartypreviouscompany != 'without') {
                  if (thirdpartydamagetype) {
                        url_param += '&Damaged=' + thirdpartydamaged;
                        url_param += '&discountDamageFinancial=' + thirdpartydiscountdamage;
                        url_param += '&discountDamageLife=' + thirdpartydiscountdamagelife;

                        url_param += '&DriverDamaged=' + thirdpartydriverdamaged;
                        url_param += '&DriverdiscountDamage=' + thirdpartydriverdiscountdamage;
                  } else {
                        url_param += '&Undamaged=' + thirdpartyundamaged;
                        url_param += '&DriverUndamaged=' + thirdpartydriverundamaged;
                  }

                  if (thirdpartyexpiredate) {
                        url_param += '&expireDate=' + thirdpartyexpiredate;
                  }
                  if (thirdpartystartdate) {
                        url_param += '&startDate=' + thirdpartystartdate;
                  }
                  if (thirdpartydiscountstatusselect) {
                        url_param += '&discountStatus=' + thirdpartydiscountstatusselect;
                  }
            }
            if (vehicleid && vehicleid != "NAN") {
                  url_param += '&vehicleId=' + vehicleid;
            }
            if (inturancetype) {
                  url_param += '&insuranceType=' + inturancetype;
            }
            url_param += '&previousCompany=' + thirdpartypreviouscompany;

            window.location = thirdpartyInsuranceSearchUrl + '/' + url_param;
      }

}

$(document).ready(function () {

      $('#thirdparty_insurance_searchBtn_top, #thirdparty_insurance_searchBtn_top-step4').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var vehicle_id = $('#thirdparty_vehicle_type_select');
            var inturance_type = $('#thirdparty_inturance_type');
            var cartype_id = $('#thirdparty_car_type_select');
            var carmodel_id = $('#thirdparty_car_model_select');
            var thirdparty_build_year = $('#thirdparty_build_year_select');
            var thirdparty_damage_type = $('#thirdparty_car_damage_type_select');
            var thirdparty_undamaged = $('#thirdparty_undamaged_select');
            var thirdparty_driver_undamaged = $('#thirdparty_driver_undamaged_select');
            var thirdparty_damaged = $('#thirdparty_damaged_select');
            var thirdparty_driver_damaged = $('#thirdparty_driver_damaged_select');
            var thirdparty_discount_damage_financial = $('#discount_damageType_financial_select');
            var thirdparty_discount_damage_life = $('#discount_damageType_life_select');
            var thirdparty_driver_discount_damage = $('#discount_driver_damageType_select');

            var thirdparty_expire_day = $('#thirdparty_expire_date_day_select');
            var thirdparty_expire_month = $('#thirdparty_expire_date_month_select');
            var thirdparty_expire_year = $('#thirdparty_expire_date_year_select');
            var thirdparty_start_day = $('#thirdparty_start_date_day_select');
            var thirdparty_start_month = $('#thirdparty_start_date_month_select');
            var thirdparty_start_year = $('#thirdparty_start_date_year_select');

            var thirdparty_owner_select = $('#thirdparty_insurance_owner_select');
            var thirdparty_previous_company_select = $('select[name="previous_company"]').filter(function () {
                  var $box = $(this).closest('#checkonline1, #checkonline2');
                  return $box.length && !$box.hasClass('d-none');
            }).first();
            if (!thirdparty_previous_company_select.length) {
                  thirdparty_previous_company_select = $('#thirdparty_previous_company_select').first();
            }

            var thirdparty_insurance_inquiry_method = $('#thirdparty_insurance_inquiry_method');

            var part4 = $('#thirdparty_part4_input');
            var part3 = $('#thirdparty_part3_input');
            var part2 = $('#thirdparty_part2_input');
            var part1 = $('#thirdparty_part1_input');
            var thirdparty_national_code = $('#thirdparty_national_code_input');
            var thirdparty_discount_status_select = $('#thirdparty_discount_status_select');

            thirdpartyInsuranceSearch(vehicle_id, inturance_type, cartype_id, carmodel_id, thirdparty_build_year,
                  thirdparty_damage_type, thirdparty_undamaged, thirdparty_damaged, thirdparty_discount_damage_financial,
                  thirdparty_discount_damage_life, thirdparty_driver_undamaged, thirdparty_driver_damaged, thirdparty_driver_discount_damage,
                  thirdparty_expire_day, thirdparty_expire_month, thirdparty_expire_year, thirdparty_start_day, thirdparty_start_month,
                  thirdparty_start_year, thirdparty_owner_select, thirdparty_previous_company_select,
                  thirdparty_insurance_inquiry_method, part1, part2, part3, part4, thirdparty_national_code, thirdparty_discount_status_select);
            return false;
      });

      $('.make-switch').each(function () {
            $(this).bootstrapSwitch('state', false);
      });

      function handleInquirySwitch(state) {
            if (state === false) {
                  // حالت دستی
                  $('#checkonline2').addClass('d-none');
                  $('#checkonline1').removeClass('d-none');
                  $('#thirdparty_insurance_searchBtn_top').addClass('d-none');
                  $('#spanonline').addClass('d-none');
                  $('#nextonline').removeClass('d-none');
                  // تاریخ‌ها فقط اگر فاقد بیمه‌نامه نباشد
                  var prev = (typeof window.tpIsWithoutPreviousPolicy === 'function')
                        ? (window.tpIsWithoutPreviousPolicy() ? 'without' : '')
                        : ($('#checkonline1 select[name="previous_company"]').val()
                              || $('#thirdparty_previous_company_select').val());
                  if (prev === 'without') {
                        $('#checkonline3').addClass('d-none tp-dates-suppressed');
                  } else {
                        $('#checkonline3').removeClass('d-none tp-dates-suppressed');
                  }
            } else {
                  // حالت آنلاین
                  $('#checkonline1').addClass('d-none');
                  $('#checkonline3').addClass('d-none').removeClass('tp-dates-suppressed');
                  $('#checkonline2').removeClass('d-none');
                  $('#thirdparty_insurance_searchBtn_top').removeClass('d-none');
                  $('#spanonline').removeClass('d-none');
                  $('#nextonline').addClass('d-none');
            }
            if (typeof window.tpTogglePreviousPolicyDates === 'function') {
                  window.tpTogglePreviousPolicyDates();
            }
      }
      // وقتی صفحه لود شد بررسی کن
      let initialState = $('#thirdparty_insurance_inquiry_method').bootstrapSwitch('state');
      handleInquirySwitch(initialState);
      // وقتی کاربر تغییرش داد بررسی کن
      $('#thirdparty_insurance_inquiry_method').on('switchChange.bootstrapSwitch', function (event, state) {
            handleInquirySwitch(state);
      });

});

var showElement = function (element) {


      if ($(element).is(':checked')) {
            $(".damaged_select").show();
            $(".damaged_select").addClass('active');

            $(".undamaged_select").hide();
            $(".undamaged_select").removeClass('active');
      } else {
            $(".damaged_select").hide();
            $(".damaged_select").removeClass('active');

            $(".undamaged_select").show();
            $(".undamaged_select").addClass('active');
      }
};
$('input[name="car_damage_type"]').bootstrapSwitch('state', true);
$('input[name="insurance_owner"]').bootstrapSwitch('state', true);
$('input[name="inquiry_method"]').bootstrapSwitch('state', true);

$.fn.extend(
      {
            animateCss: function (animationName) {
                  var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                  this.addClass('animated ' + animationName).one(
                        animationEnd, function () {
                              $(this).removeClass('animated ' + animationName);
                        }
                  );
            }
      }
);



